// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"AddOnsDiningAllPopup_CheckBox__1XpVj","count_wrapper":"AddOnsDiningAllPopup_count_wrapper__2E4E5","field_input_count":"AddOnsDiningAllPopup_field_input_count__1lDfm"};